export const DIWALI_2026_CTA_LABEL = 'Save Now';
export const DIWALI_2026_EYEBROW_LABEL = 'ENDS SOON';

export const DIWALI_2026_COLORS = {
  accent: 'orange.300',
  background: '#000000',
  catalogBorder: 'orange.500',
  catalogCta: 'orange.700',
  catalogSubtitle: 'purple.300',
  cta: 'purple.700',
  dividerGradient: 'linear(to-r, orange.300, purple.500)',
} as const;

export const DIWALI_2026_CATALOG_BG_GRADIENT = {
  base: 'linear-gradient(115.77deg, rgba(147, 28, 245, 0.2) 4.86%, rgba(195, 80, 0, 0.2) 105.04%)',
  md: 'linear-gradient(116.46deg, rgba(147, 28, 245, 0.2) 8.97%, rgba(195, 80, 0, 0.2) 105.39%)',
} as const;

const ASSET_DIR = '/images/promotions/diwali-2026';

export const DIWALI_2026_ASSETS = {
  catalogBg: `${ASSET_DIR}/catalog-bg.webp`,
  catalogBgMobile: `${ASSET_DIR}/catalog-bg-mobile.webp`,
  experienceAtfBg: `${ASSET_DIR}/experience-atf-bg.webp`,
  experienceAtfBgMobile: `${ASSET_DIR}/experience-atf-bg-mobile.webp`,
  homepageBg: `${ASSET_DIR}/homepage-bg.webp`,
  homepageBgMobile: `${ASSET_DIR}/homepage-bg-mobile.webp`,
} as const;

export const DIWALI_2026_COPY = {
  titleLine1: 'Diwali early',
  titleLine2: 'access sale',
  homepageSubtitle:
    'A brighter future starts here! Celebrate the Festival of Lights with a special offer on AI & tech programs.',
  catalogHeadlineLine1: 'Diwali early-access sale',
  catalogHeadlineLine2: 'on all programs.',
  catalogSubtitle: 'Explore AI & tech skills for your next big move.',
  experienceSubtitle: 'Let your skills shine! Discover\nyour next opportunity in AI & tech.',
} as const;

export const DIWALI_2026_CHECKOUT_HREF = '/checkout/individual/annually/credit-card';

export function getDiwali2026CheckoutHref(promoCode?: string | null): string {
  const href = DIWALI_2026_CHECKOUT_HREF;
  if (!promoCode) {
    return href;
  }
  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}coupon=${encodeURIComponent(promoCode)}`;
}
